module.exports = __webpack_public_path__ + "media/images/sp/stores/common/instagram/hairmake_sns_02-8c5fa0f28a21577d900ba3100563432f.jpg";